import { ModalComponent2 } from './modal/modal.component';
import { MainSideBarComponent } from './main-side-bar/main-side-bar.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { ButtonComponent } from './button/button.component';
import { TabsComponent } from './tabs/tabs.component';
import { ExternalUrlComponent } from './external-url/external-url.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationTypeActionComponent } from './notification/notification-type-action/notification-type-action.component';
import { PolicyCancellationDetailsComponent } from './notification/policy-cancellation-details/policy-cancellation-details.component';
var components = [
    ModalComponent2,
    MainSideBarComponent,
    SnackBarComponent,
    ButtonComponent,
    TabsComponent,
    ExternalUrlComponent,
    NotificationComponent,
    NotificationTypeActionComponent,
    PolicyCancellationDetailsComponent
];
var SharedComponentsModule = /** @class */ (function () {
    function SharedComponentsModule() {
    }
    return SharedComponentsModule;
}());
export { SharedComponentsModule };
